<template>
  <CNavbar expand="lg" class="navbar-custom py-2 px-4">
    <CContainer fluid class="d-flex align-items-center">
      
      <router-link to="/dashboard" class="me-4 home-link" :class="{ 'active': isActive('/dashboard') }" title="Inicio">
        <CIcon icon="cilHome" size="xl" />
      </router-link>

      <CNavbarNav class="d-flex align-items-center gap-4 flex-grow-1">
        <CNavItem  :class="{ 'active-item': isActive('/customers') }">
          <router-link to="/customers">
            <CNavLink href="#" class="nav-link-custom" :class="{'active': isActive('/customers')}">CLIENTES</CNavLink>
          </router-link>
            <div :class="{ 'active-indicator': isActive('/customers') }" ></div>
          
        </CNavItem>

        <CNavItem  class="position-relative" :class="{ 'active-item': isActive('/tasks') }">

          <router-link to="/tasks">
            <CNavLink href="#"  class="nav-link-custom" :class="{'active': isActive('/tasks')}">
              TAREAS
              <CBadge v-if="count_tasks" color="danger" position="top-end" shape="rounded-pill" class="ml-auto">{{ count_tasks }}</CBadge>
            </CNavLink>
          </router-link>
          <div :class="{ 'active-indicator': isActive('/tasks') }" ></div>
        </CNavItem>

        <CNavItem :class="{ 'active-item': isActive('/reminder1') }">
           <router-link to="/reminder1">
          <CNavLink href="#" class="nav-link-custom" :class="{'active': isActive('/reminder1')}">RECORDATORIOS</CNavLink>
         </router-link>
          <div :class="{ 'active-indicator': isActive('/reminder1') }" ></div>
        </CNavItem>

        <CNavItem :class="{ 'active-item': isActive('/revision') }">
           <router-link to="/revision">
          <CNavLink href="#" class="nav-link-custom" :class="{'active': isActive('/revision')}">REVISIÓN</CNavLink>
         </router-link>
          <div :class="{ 'active-indicator': isActive('/revision') }" ></div>
        </CNavItem>

        <CNavItem :class="{ 'active-item': isActive('/cima') }"  v-if="userStore?.getUser?.admin || user_permissions.some(user_permission => user_permission.key == 'cima')">
           <router-link to="/cima">
          <CNavLink href="#" class="nav-link-custom" :class="{'active': isActive('/cima')}">CIMA</CNavLink>
         </router-link>
          <div :class="{ 'active-indicator': isActive('/cima') }" ></div>
        </CNavItem>

        <CNavItem :class="{ 'active-item': isActive('/collaborators') }">
           <router-link to="/collaborators">
          <CNavLink href="#" class="nav-link-custom" :class="{'active': isActive('/collaborators')}">COLABORADORES</CNavLink>
         </router-link>
          <div :class="{ 'active-indicator': isActive('/collaborators') }" ></div>
        </CNavItem>

        <CNavItem :class="{ 'active-item': isActive('/users') }" v-if="userStore?.getUser?.admin || userStore?.getUser?.is_local_admin">
          <router-link to="/users">
            <CNavLink class="nav-link-custom" :class="{'active': isActive('/users')}">USUARIOS</CNavLink>
          </router-link>
          <div :class="{ 'active-indicator': isActive('/users') }" ></div>
        </CNavItem>

        <CNavItem :class="{ 'active-item': isActive('/oficinas') }" v-if="userStore?.getUser?.admin">
          <router-link to="/oficinas">
            <CNavLink class="nav-link-custom" :class="{'active': isActive('/oficinas')}">OFICINAS</CNavLink>
          </router-link>
          <div :class="{ 'active-indicator': isActive('/oficinas') }" ></div>
        </CNavItem>

        <CNavItem :class="{ 'active-item': isActive('/analytics') }" v-if="userStore?.getUser?.admin || userStore?.getUser?.is_local_admin">
          <router-link to="/analytics">
            <CNavLink class="nav-link-custom" :class="{'active': isActive('/analytics')}">ANÁLISIS</CNavLink>
          </router-link>
          <div :class="{ 'active-indicator': isActive('/analytics') }" ></div>
        </CNavItem>
      </CNavbarNav>

      <div class="ms-auto d-flex align-items-center">
        <!--<CAvatar src="https://i.pravatar.cc/150?img=11" size="md" class="border border-2 border-white shadow-sm" />-->
        <AppHeaderDropdownAccnt></AppHeaderDropdownAccnt>
      </div>

    </CContainer>
  </CNavbar>

  <!--<div class="header-nav">
    <button class="menu-toggle" @click="toggleMenu">
      ☰ Menu
    </button>
    <nav class="menu" :class="{ 'menu-open': menuOpen }">
      <div class="menu-links">
        <router-link
          to="/dashboard"
          class="menu-item"
          :class="{ active: isActive('/dashboard') }"
          @click="closeMenu"
        >DASHBOARD</router-link>
        <router-link
          to="/customers"
          class="menu-item"
          :class="{ active: isActive('/customers') }"
          @click="closeMenu"
        >CLIENTES</router-link>
        <router-link
          to="/tasks"
          class="menu-item"
          :class="{ active: isActive('/tasks') }"
          @click="closeMenu"
        >TAREAS</router-link>
        <router-link
          to="/reminder1"
          class="menu-item"
          :class="{ active: isActive('/reminder1') }"
          @click="closeMenu"
        >RECORDATORIOS</router-link>
        <router-link
          to="/revision"
          class="menu-item"
          :class="{ active: isActive('/revision') }"
          @click="closeMenu"
        >REVISIÓN</router-link>
         <router-link
          v-if="userStore?.getUser?.admin"
          to="/cima"
          class="menu-item"
          :class="{ active: isActive('/cima') }"
          @click="closeMenu"
        >CIMA</router-link>
         <router-link
          to="/collaborators"
          class="menu-item"
          :class="{ active: isActive('/collaborators') }"
          @click="closeMenu"
        >COLABORADORES</router-link>
        router-link
          to="/opportunities"
          class="menu-item"
          :class="{ active: isActive('/opportunities') }"
          @click="closeMenu"
        >OPORTUNIDADES</router-link>
        <router-link
          v-if="userStore?.getUser?.admin"
          to="/users"
          class="menu-item"
          :class="{ active: isActive('/users') }"
          @click="closeMenu"
        >Usuarios</router-link>
      </div>
      <div class="dropdown-container">
        <AppHeaderDropdownAccnt />
      </div>
    </nav>
  </div>-->
</template>

<script>
import AppHeaderDropdownAccnt from './AppHeaderDropdownAccnt'
import { useUserStore } from '@/plugins/store';
import axios from 'axios'
import Pusher from 'pusher-js'

var Sidebar;

export default {
  name: 'AppHeaderNav',
  data() {
    return {
      menuOpen: false,
      count_tasks: 0,
      user_permissions: []
    };
  },
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  mounted(){
    this.user = this.userStore.getUser
    Sidebar = this
    
    if (process.env.NODE_ENV === 'production') {
      const pusherKey = process.env.VUE_APP_PUSHER_KEY || '91ab7afa0f283ea405d5';
      const pusherCluster = process.env.VUE_APP_PUSHER_CLUSTER || 'eu';

      var pusher = new Pusher(pusherKey, {
        cluster: pusherCluster
      });

      var channel = pusher.subscribe('my-notification-'+this.user?.id);

      channel.bind(`my-notification-event`, function() {
        Sidebar.getCountTasks()
      });
    }

    this.getCountTasks()
    this.getUserPermissions()
  },
  methods: {
    isActive(path) {
      return this.$route && this.$route.path === path;
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    getCountTasks(){
      let url =  '/v1/tasks/Pendiente/status';
      axios
      .get(url)
      .then(resp => {
        let items = resp.data.filter((thing, index) => {
          const _thing = JSON.stringify(thing);
          return index ===  resp.data.findIndex(obj => {
            return JSON.stringify(obj) === _thing;
          });
        });
        this.count_tasks = items.length
      })
      .catch(err => console.log(err));
    },
    getUserPermissions() {
      const userId = this.user?.id || null;
      axios
        .get(`permissions/`+userId)
        .then(res => {
          this.user_permissions = res.data;
        })
        .catch(err => console.log(err));
    },
  },
  components: {
    AppHeaderDropdownAccnt,
  },
};
</script>

<style scoped>
.header-nav {
  background-color: #003d4d;
  position: relative;
}

/* Botón para dispositivos móviles */
.menu-toggle {
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  margin-bottom: 10px;
}

.menu-item {
  color: white;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  text-decoration: none;
  padding: 8px 15px;
  border-radius: 5px;
}

.menu-item:hover {
  background-color: #007bff;
}

.menu-item.active {
  background-color: white;
  color: #003d4d;
}
.menu {
  display: flex;
  align-items: center;
  width: 100%;
  
}

.menu-links {
  display: flex;
  gap: 15px;
  flex-grow: 1; /* Esto hace que ocupe el espacio disponible */
}

.dropdown-container {
  margin-left: auto; /* Empuja el dropdown al final de la barra */
}

/* Estilos para dispositivos móviles */
@media (max-width: 768px) {
  .menu {
    flex-direction: column;
    align-items: flex-start;
    display: none; /* Oculta el menú por defecto en móviles */
    gap: 5px;
    background-color: #003d4d; /* Fondo para el menú desplegable */
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    
  }

  .menu.menu-open {
    display: flex; /* Muestra el menú cuando se abre en móviles */
  }

  .menu-toggle {
    display: block; /* Muestra el botón de menú en móviles */
  }

  .menu-item {
    width: 100%; /* Hace que los enlaces del menú ocupen el ancho completo */
    padding: 10px 15px;
    border-radius: 0;
  }
}

/* Color de fondo azul petróleo profundo de la imagen */
.navbar-custom {
  background-color: #1a434e !important;
  min-height: 70px;
}

/* Estilo de los enlaces */
.nav-link-custom {
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  padding: 0.5rem 0 !important;
  transition: color 0.3s ease;
}

.nav-link-custom:hover, 
.nav-link-custom.active {
  color: #ffffff !important;
}

/* Contenedor del item activo para manejar la línea inferior */
.active-item {
  position: relative;
}

.active-indicator {
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #00cba9; /* Color verde azulado de la imagen */
  border-radius: 2px;
}

/* Color del icono de la izquierda */
.text-light-teal {
  color: #6fbdb1;
}

.home-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #9ed3ca;
  transition: color .15s, transform .1s;
}
.home-link:hover { color: #fff; transform: translateY(-1px); }
.home-link.active { color: #fff; }



.cursor-pointer {
  cursor: pointer;
}

/* Ajuste de mayúsculas para que coincida con la imagen */
.text-uppercase {
  text-transform: uppercase;
}

.nav-item a{
  color: transparent;
    text-decoration: none;
}
</style>
